import React from 'react';
import PetOwnerEditForm from './PetOwnerEditForm';
import { useEscapeKey } from '../../hooks/useEscapeKey';

interface PetOwnerEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  ownerUuid: string;
}

const PetOwnerEditModal: React.FC<PetOwnerEditModalProps> = ({ isOpen, onClose, onSuccess, ownerUuid }) => {
  useEscapeKey(onClose, isOpen);
  
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 bg-black bg-opacity-30 transition-opacity"
      onClick={onClose}
    >
      <div
        className="fixed right-0 top-0 h-full w-full max-w-xl bg-white shadow-2xl transform transition-transform duration-300 ease-out overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        style={{ transform: isOpen ? 'translateX(0)' : 'translateX(100%)' }}
      >
        <PetOwnerEditForm 
          onClose={onClose} 
          onSuccess={onSuccess} 
          ownerUuid={ownerUuid}
        />
      </div>
    </div>
  );
};

export default PetOwnerEditModal;

